<template>
  <v-form v-model="valid" ref="form">
    <v-container fluid>
      <v-row>
        <v-col cols="6" sm="3" lg="2">
          <v-tooltip bottom max-width="300" nudge-top="20">
            <template v-slot:activator="{on}">
              <v-checkbox v-model="item.sold" v-on="on">
                <span slot="label" v-on="on">This item is sold</span>
              </v-checkbox>
            </template>
            If not marked as being sold, you won't be able to find the item
            in lists when selecting items for sale such as a shipment or
            the Shopify add-on.
            This is simply to keep those lists manageable.
          </v-tooltip>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="8" md="6">
          <v-text-field label="Description on sales forms" v-model="item.sellingDescription" :rules="[fieldRules.maxLength(100)]" :counter="100" outlined dense :disabled="!item.sold"/>
        </v-col>
      </v-row>
      <v-row dense v-if="connectedToAccounting && values">
        <v-col cols="12" sm="6" md="4">
          <account-picker v-model="item.incomeAccountRef" label="Income account"
                          :accounts="item.type=='Item' ? incomeAccounts : accounts"  :addTypes="['Income']"
                          hint="The income account is used to track sales of this item."
                          :disabled="!item.sold"/>
        </v-col>
        <v-col cols="12" sm="6" md="4" v-if="item.type=='Item'">
          <account-picker v-model="item.cogAccountRef" label="COG account"
                          :accounts="cogAccounts"  :addTypes="['CostOfGoodsSold']"
                          hint="The cost of goods account is used to track sales of this item"
                          :disabled="!item.sold"/>
        </v-col>
      </v-row>
      <v-row >
        <v-col cols="6" sm="3" md="2">
          <decimal-number-input dense label="Default price" v-model="item.defaultPrice" :precision="4" :disabled="!item.sold"/>
        </v-col>
        <v-col cols="6" sm="3" md="2">
          <v-autocomplete  outlined dense label="Default tax" v-model="item.defaultTaxId" :items="taxes" item-value="id" item-text="name" :disabled="!item.sold"/>
        </v-col>
        <v-col cols="6" sm="3" md="2" v-if="item.type!=='Service'">
          <decimal-number-input label="Unit weight" v-model="item.weight" prefix="" suffix="kg" :precision="3"
                                hint="For shipping documents" :disabled="!item.sold"/>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" md="10" lg="8">
          <customer-pricing :customers="item.customers" :taxes="taxes"
                            :default-sku="item.sku" :defaultPrice="item.defaultPrice" :defaultTaxId="item.defaultTaxId" :disabled="!item.sold"/>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="4" md="3">
          <v-checkbox dense label="Commission exempt" v-model="item.commissionExempt" :disabled="!item.sold"/>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import CustomerPricing from '@/components/CustomerPricing'

export default {
  name: 'InventoryItemsEditSelling',
  components: {CustomerPricing},
  props: {
    item: {type:Object, required:true},
    taxes: {type:Array, required:true},
    accounts: {type:Array, required:true},
    values: {type:Boolean, required:true}
  },
  data() {
    return {
      valid: true
    }
  },
  computed: {
    connectedToAccounting() {
      return this.$store.getters.company.connectedToAccounting;
    },
    incomeAccounts() {
      return this.accounts.filter(account => account.type === 'Income');
    },
    cogAccounts() {
      return this.accounts.filter(account => account.type === 'CostOfGoodsSold');
    }
  }
}
</script>
